var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M22.5 0H7.5C3.36 0 0 3.345 0 7.47V16.44V17.94C0 22.065 3.36 25.41 7.5 25.41H9.75C10.155 25.41 10.695 25.68 10.95 26.01L13.2 28.995C14.19 30.315 15.81 30.315 16.8 28.995L19.05 26.01C19.335 25.635 19.785 25.41 20.25 25.41H22.5C26.64 25.41 30 22.065 30 17.94V7.47C30 3.345 26.64 0 22.5 0ZM9 15C8.16 15 7.5 14.325 7.5 13.5C7.5 12.675 8.175 12 9 12C9.825 12 10.5 12.675 10.5 13.5C10.5 14.325 9.84 15 9 15ZM15 15C14.16 15 13.5 14.325 13.5 13.5C13.5 12.675 14.175 12 15 12C15.825 12 16.5 12.675 16.5 13.5C16.5 14.325 15.84 15 15 15ZM21 15C20.16 15 19.5 14.325 19.5 13.5C19.5 12.675 20.175 12 21 12C21.825 12 22.5 12.675 22.5 13.5C22.5 14.325 21.84 15 21 15Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }